<ion-button (click)="open(file.url, file)" *ngFor="let file of files" color="tertiary" expand="full" fill="clear">
  <ion-icon slot="start" name="attach-outline"></ion-icon>
  {{ file.name }}
</ion-button>
